<template lang="pug">
  .main-container
    .column
      .row.middle.space-between.m-bottom-4
        h1.title-medium
          | {{ isOwn ? $t('krea.resources.myResources') : $t('krea.resources.schoolsGroupResources') }}
        router-link(v-if='myResources.length' :to='{name: routes.kreaNewResource}')
          button.main-button {{ $t('krea.resources.newResource') }}
      resources-list(:ownList='isOwn')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { routes } from '../router'
import ResourcesList from '@/components/Krea/Resources/ResourcesList'

export default {
  components: { ResourcesList },
  data() {
    return {
      routes
    }
  },
  computed: {
    ...mapState({
      myResources: state => state.kreaResources.myResources.resources,
      schoolsGroupResources: state => state.kreaResources.schoolsGroupResources.resources,
      userInfo: state => state.userInfo.userInfo
    }),
    isOwn() {
      return this.$route.name === routes.kreaMyResources
    }
  },
  methods: {
    ...mapActions([
      'clearKreaResources',
      'showElement',
      'hideElement'
    ])
  },
  beforeDestroy() {
    this.clearKreaResources()
  }
}
</script>

<style lang="scss" scoped>

</style>
